import type { List } from '@src/@types/microcredits';

export const isMetadataInvalid = (metadata: List.IMetadata) =>
  // @todo: нам в каком то случае может прийти метадата с нулевыми значениями,
  // мы считаем ее не корректной и не отображаем фильтры
  [metadata.minTerm.termValue, metadata.maxTerm.termValue, metadata.minAmount.amount, metadata.maxAmount.amount].every(
    (item) => item === 0,
  );
